module.exports = __webpack_public_path__ + "static/media/progman_46.53e67708.ico";